import { OmitType } from '../../codegen';

import { Subscription } from './subscription.entity';

export class SubscriptionReturnDto extends OmitType(Subscription, [
  'accountId',
  'acquirerSubscriptionId',
  'createdAt',
]) {}
